// @refresh reset
import { useContext } from 'react';
import { SalesDataContext } from '../../../contexts/dataContextSlices.js';

export function useSalesData() {
  const value = useContext(SalesDataContext);
  if (!value) {
    throw new Error('useSalesData must be used within DataProvider');
  }
  return value;
}
